<div class="min-h-screen bg-[#faf8f5]" style="font-family: sans-serif;">

  <!-- ═══ CAROUSEL SLIDER ═══ -->
  <div class="relative overflow-hidden bg-white">
    <!-- Slides -->
    <div *ngIf="slides.length > 0" class="relative">
      <div *ngFor="let slide of slides; let i = index"
        [class]="'transition-opacity duration-700 ' + (i === currentSlide ? 'block' : 'hidden')">
        <a [href]="slide.button_link || '#'" class="block">
          <!-- Mobile image -->
          <img *ngIf="slide.mobile_image" [src]="slide.mobile_image" [alt]="slide.alt_text || 'Banner'"
            class="w-full h-auto block md:hidden" />
          <!-- Desktop image -->
          <img [src]="slide.image" [alt]="slide.alt_text || 'Banner'"
            [ngClass]="slide.mobile_image ? 'hidden md:block' : 'block'"
            class="w-full h-auto" />
        </a>
      </div>
      <!-- Dots -->
      <div *ngIf="slides.length > 1" class="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-2 z-10">
        <button *ngFor="let s of slides; let i = index" (click)="goToSlide(i)"
          [class]="'w-2.5 h-2.5 rounded-full transition-all ' + (i === currentSlide ? 'bg-[#600b0b] scale-125' : 'bg-gray-300 hover:bg-gray-400')"></button>
      </div>
    </div>
  </div>

  <!-- ═══ FRAME BY SIZE (from settings API: services) ═══ -->
  <div class="bg-white py-8 md:py-12">
    <div class="max-w-[1200px] mx-auto px-4">
      <!-- Section Title (dynamic from headings) -->
      <div class="text-center mb-8">
        <h2 class="text-xl md:text-2xl text-gray-900" style="font-family: 'Roboto Slab', serif;">{{ headings[0]?.title || 'Frame By Size' }}</h2>
        <div class="flex items-center justify-center mt-2">
          <img src="assets/images/H1-separator.png" alt="" class="h-5" />
        </div>
      </div>

      <!-- Loading skeleton -->
      <div *ngIf="services.length === 0 && isLoading" class="grid grid-cols-2 md:grid-cols-4 gap-6">
        <div *ngFor="let i of [1,2,3,4]" class="text-center">
          <div class="aspect-square bg-gray-200 animate-pulse mx-auto max-w-[200px]"></div>
          <div class="h-4 bg-gray-200 rounded animate-pulse w-3/4 mx-auto mt-3"></div>
          <div class="h-4 bg-gray-100 rounded animate-pulse w-1/2 mx-auto mt-1.5"></div>
        </div>
      </div>

      <!-- Frame items from services API -->
      <div *ngIf="services.length > 0" class="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
        <div *ngFor="let frame of services" class="text-center cursor-pointer group">
          <a [href]="frame.button_link || '#'">
            <!-- Image with hover swap -->
            <div class="relative mx-auto max-w-[200px] overflow-hidden">
              <img [src]="frame.image" [alt]="frame.alt_text || ''"
                class="w-full aspect-square object-contain transition-opacity duration-300 group-hover:opacity-0" />
              <img *ngIf="frame.mobile_image" [src]="frame.mobile_image" [alt]="frame.alt_text || ''"
                class="absolute inset-0 w-full h-full object-contain opacity-0 transition-opacity duration-300 group-hover:opacity-100 bg-white" />
            </div>
          </a>
          <a [href]="frame.button_link || '#'" class="block mt-3 group-hover:text-[#600b0b] transition-colors">
            <div [innerHTML]="frame.title" class="text-xs md:text-sm text-gray-800 font-medium"></div>
            <div [innerHTML]="frame.subtitle" class="text-sm md:text-base font-bold text-gray-900 mt-0.5"></div>
          </a>
        </div>
      </div>
    </div>
  </div>

  <!-- ═══ NEW ARRIVALS (from settings API: home_decors) ═══ -->
  <div class="bg-[#faf8f5] py-8 md:py-12">
    <div class="max-w-[1200px] mx-auto px-4">
      <!-- Section Title (dynamic heading[0]) -->
      <div class="text-center mb-8">
        <h2 class="text-xl md:text-2xl text-gray-900" style="font-family: 'Roboto Slab', serif;">{{ headings[1]?.title || 'New Arrivals' }}</h2>
        <div class="flex items-center justify-center mt-2">
          <img src="assets/images/H1-separator.png" alt="" class="h-5" />
        </div>
      </div>

      <!-- Loading skeleton -->
      <div *ngIf="homeDecors.length === 0 && isLoading" class="grid grid-cols-2 md:grid-cols-4 gap-6">
        <div *ngFor="let i of [1,2,3,4]" class="text-center">
          <div class="aspect-square bg-gray-200 animate-pulse mx-auto"></div>
          <div class="h-4 bg-gray-200 rounded animate-pulse w-3/4 mx-auto mt-3"></div>
          <div class="h-4 bg-gray-100 rounded animate-pulse w-1/2 mx-auto mt-1.5"></div>
        </div>
      </div>

      <!-- 4 items from home_decors API -->
      <div *ngIf="homeDecors.length > 0" class="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
        <div *ngFor="let item of homeDecors" class="text-center cursor-pointer group">
          <a [href]="item.button_link || '#'">
            <!-- Image with hover swap -->
            <div class="relative mx-auto overflow-hidden">
              <img [src]="item.image" [alt]="item.alt_text || ''"
                class="w-full aspect-square object-contain transition-opacity duration-300 group-hover:opacity-0"
                (error)="$any($event.target).src = 'assets/images/product/on_sale/framed-art.jpg'" />
              <img *ngIf="item.mobile_image" [src]="item.mobile_image" [alt]="item.alt_text || ''"
                class="absolute inset-0 w-full h-full object-contain opacity-0 transition-opacity duration-300 group-hover:opacity-100 bg-white"
                (error)="$any($event.target).style.display='none'" />
            </div>
          </a>
          <a [href]="item.button_link || '#'" class="block mt-3 group-hover:text-[#600b0b] transition-colors">
            <div [innerHTML]="item.title" class="text-xs md:text-sm text-gray-800 font-medium"></div>
            <div [innerHTML]="item.subtitle" class="text-sm md:text-base font-bold text-gray-900 mt-0.5"></div>
          </a>
        </div>
      </div>

      <!-- View More button -->
      <div class="text-center mt-8">
        <button (click)="navigateTo('/print-frame/featured-frames')"
          class="bg-[#600b0b] text-white px-8 py-2.5 text-[10px] md:text-xs font-bold uppercase tracking-[0.2em] hover:bg-[#8c1c1c] transition-all">
          VIEW MORE
        </button>
      </div>
    </div>
  </div>

  <!-- ═══ GET IN TOUCH ═══ -->
  <div class="py-8 md:py-12" style="background-color: rgb(253, 245, 245);">
    <div class="max-w-[900px] mx-auto px-4">
      <!-- Section Title -->
      <div class="text-center mb-6">
        <h2 class="text-xl md:text-2xl text-gray-900" style="font-family: 'Roboto Slab', serif;">Get In Touch</h2>
        <p class="text-xs text-gray-500 mt-1">Send us a message, we will respond shortly.</p>
        <div class="flex items-center justify-center mt-2">
          <img src="assets/images/H1-separator.png" alt="" class="h-5" />
        </div>
      </div>

      <!-- Success message -->
      <div *ngIf="formSuccess" class="bg-green-50 border border-green-200 text-green-700 text-sm text-center py-3 px-4 rounded-lg mb-4">
        Thank you for contacting us. Our agent will contact you within 24 hours.
      </div>

      <!-- Error message -->
      <div *ngIf="formError" class="bg-red-50 border border-red-200 text-red-700 text-sm text-center py-3 px-4 rounded-lg mb-4">
        There is some error. Please try again.
      </div>

      <!-- Contact Form -->
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div class="space-y-4">
          <input [(ngModel)]="contactForm.name" type="text" placeholder="Name *"
            class="w-full border border-gray-300 bg-white px-4 py-2.5 text-sm outline-none focus:border-[#600b0b] transition-colors" />
          <input [(ngModel)]="contactForm.email" type="email" placeholder="Email *"
            class="w-full border border-gray-300 bg-white px-4 py-2.5 text-sm outline-none focus:border-[#600b0b] transition-colors" />
          <p *ngIf="contactForm.email && !isEmailValid" class="text-[10px] text-red-500 -mt-2">Please enter a valid email address</p>
          <input [(ngModel)]="contactForm.contact" type="text" placeholder="Contact *" maxlength="10"
            class="w-full border border-gray-300 bg-white px-4 py-2.5 text-sm outline-none focus:border-[#600b0b] transition-colors" />
        </div>
        <div>
          <textarea [(ngModel)]="contactForm.requirement" placeholder="Query *" rows="4"
            class="w-full border border-gray-300 bg-white px-4 py-2.5 text-sm outline-none focus:border-[#600b0b] transition-colors resize-none h-full min-h-[140px]"></textarea>
        </div>
      </div>
      <div class="text-center mt-5">
        <button (click)="submitQuery()" [disabled]="formSubmitting || (contactForm.email && !isEmailValid)"
          class="bg-[#600b0b] text-white px-8 py-2.5 text-[10px] md:text-xs font-bold uppercase tracking-[0.2em] hover:bg-[#8c1c1c] transition-all disabled:opacity-50">
          {{ formSubmitting ? 'SENDING...' : 'SEND QUERY' }}
        </button>
      </div>
    </div>
  </div>

</div>
